<div class="tile-dashlet">
  <span>{{ dashlet.description }}</span>
  <span *ngIf="actionResponse$ | async as actionResponse; else loading" class="tile-dashlet__result">{{
    actionResponse['result']
  }}</span>
  <ng-template #loading>
    <div class="p-skeleton tile-dashlet__skeleton"></div>
  </ng-template>
</div>
